module.exports = __webpack_public_path__ + "img/17.65f9587c.png";